import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SurveyForm from './components/SurveyForm';
import AdminSurvey from './components/AdminSurvey';

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin panel */}
        <Route path="/survey/admin" element={<AdminSurvey />} />

        {/* HotTopics partner routes */}
        <Route path="/survey/HotTopics/marketing" element={<SurveyForm version="marketing" partner="HotTopics" />} />
        <Route path="/survey/HotTopics/founder" element={<SurveyForm version="founder" partner="HotTopics" />} />
        <Route path="/survey/HotTopics" element={<Navigate to="/survey/HotTopics/founder" replace />} />
        <Route path="/survey/HotTopics/*" element={<Navigate to="/survey/HotTopics/founder" replace />} />

        {/* Default Marketing version */}
        <Route path="/survey/marketing" element={<SurveyForm version="marketing" />} />

        {/* Default Founder version */}
        <Route path="/survey/founder" element={<SurveyForm version="founder" />} />

        {/* Default survey route - redirects to founder */}
        <Route path="/survey" element={<Navigate to="/survey/founder" replace />} />

        {/* Root path - redirects to default survey */}
        <Route path="/" element={<Navigate to="/survey/founder" replace />} />

        {/* Catch all - redirect to default */}
        <Route path="*" element={<Navigate to="/survey/founder" replace />} />
      </Routes>
    </Router>
  );
}

export default App;